import DollarTagIcon from '../../../../../icons/dollar-tag.svg';
import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg';
import UserIcon from '../../../../../icons/user.svg';
import DocumentIcon from '../../../../../icons/document.svg';

export default function PurchasingProcessData() {
    return {
        image: "/product-landing/term/circle1.png",
        steps: [
            {
                title: "Get a Quote",
                icon: DollarTagIcon,
                paragraphs: [
                    "We tried to make this easy. Use the quoter above to enter your information to get quotes from across the industry. We put the cheapest offers first.",
                ]
            },
            {
                title: "Select and Apply",
                icon: HandSelectClickIcon,
                paragraphs: [
                    "After you have entered some contact information, one of our insurance experts will be able to walk you through the application process.",
                ]
            },
            {
                title: "First Call",
                icon: UserIcon,
                paragraphs: [
                    "Our licensed insurance experts will ask you some basic questions to determine which carrier is going to be the best fit for you. Our team will do everything they can to make this call as short and straightforward as possible. By having the following information available, we will help you speed up the application process:",
                    [
                        "Medical information - Names and contact information for your primary physician, prescribed medication names and dosages, etc.",
                        "Personal information - SSN, driver’s license, address, etc.",
                        "Personal income information - Income, assets, and total debt.",
                        "Beneficiary information - Names, address, date of birth, etc. (Beneficiaries are those individuals you would want to receive the death benefit if something were to happen)",
                    ]

                ]
            },
            {
                title: "Finish your Underwriting Process",
                icon: DocumentIcon,
                paragraphs: [
                    "We will work directly with the carrier to get you an offer. Keep an eye on your inbox as we will keep you in the loop from start to finish.",
                ]
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Disability/PurchasingProcessData.js